const CommonTypes = {
  ADD_TO_CURRENT_QUOTE_CARRIERS: 'COMMON_TYPES.ADD_TO_CURRENT_QUOTE_CARRIERS',
  ADD_TO_CURRENT_QUOTE_COLLABORATORS: 'COMMON_TYPES.ADD_TO_CURRENT_QUOTE_COLLABORATORS',
  CREATE_SPOT_QUOTE_ERROR: 'COMMON_TYPES.CREATE_SPOT_QUOTE_ERROR',
  CREATE_SPOT_QUOTE_PROGRESS: 'COMMON_TYPES.CREATE_SPOT_QUOTE_PROGRESS',
  CREATE_SPOT_QUOTE_RESET: 'COMMON_TYPES.CREATE_SPOT_QUOTE_RESET',
  CREATE_SPOT_QUOTE_SUCCESS: 'COMMON_TYPES.CREATE_SPOT_QUOTE_SUCCESS',
  GET_CARRIER_DETAILS_ERROR: 'COMMON_TYPES.GET_CARRIER_DETAILS_ERROR',

  GET_CARRIER_DETAILS_PROGRESS: 'COMMON_TYPES.GET_CARRIER_DETAILS_PROGRESS',
  GET_CARRIER_DETAILS_SUCCESS: 'COMMON_TYPES.GET_CARRIER_DETAILS_SUCCESS',
  GET_CARRIER_SEARCH_ERROR: 'COMMON_TYPE.GET_CARRIER_SEARCH_ERROR',

  GET_CARRIER_SEARCH_PROGRESS: 'COMMON_TYPE.GET_CARRIER_SEARCH_PROGRESS',
  GET_CARRIER_SEARCH_RESET: 'COMMON_TYPE.GET_CARRIER_SEARCH_RESET',
  GET_CARRIER_SEARCH_SUCCESS: 'COMMON_TYPE.GET_CARRIER_SEARCH_SUCCESS',
  GET_CURRENT_QUOTE_CARRIERS_LIST: 'COMMON_TYPES.GET_CURRENT_QUOTE_CARRIERS_LIST',
  GET_CURRENT_QUOTE_COLLABORATORS_LIST: 'COMMON_TYPES.GET_CURRENT_QUOTE_COLLABORATORS_LIST',
  GET_NEW_SPOT_QUOTE_NO_ERROR: 'COMMON_TYPES.GET_NEW_SPOT_QUOTE_NO_ERROR',
  GET_NEW_SPOT_QUOTE_NO_IN_PROGRESS: 'COMMON_TYPES.GET_NEW_SPOT_QUOTE_NO_IN_PROGRESS',
  GET_NEW_SPOT_QUOTE_NO_SUCCESS: 'COMMON_TYPES.GET_NEW_SPOT_QUOTE_NO_SUCCESS',
  GET_PORT_SEARCH_ERROR: 'COMMON_TYPE.GET_PORT_SEARCH_ERROR',

  GET_PORT_SEARCH_PROGRESS: 'COMMON_TYPE.GET_PORT_SEARCH_PROGRESS',
  GET_PORT_SEARCH_RESET: 'COMMON_TYPE.GET_PORT_SEARCH_RESET',
  GET_PORT_SEARCH_SUCCESS: 'COMMON_TYPE.GET_PORT_SEARCH_SUCCESS',
  GET_POSTAL_SEARCH_ERROR: 'COMMON_TYPE.GET_POSTAL_SEARCH_ERROR',

  GET_POSTAL_SEARCH_PROGRESS: 'COMMON_TYPE.GET_POSTAL_SEARCH_PROGRESS',
  GET_POSTAL_SEARCH_RESET: 'COMMON_TYPE.GET_POSTAL_SEARCH_RESET',
  GET_POSTAL_SEARCH_SUCCESS: 'COMMON_TYPE.GET_POSTAL_SEARCH_SUCCESS',
  GET_SPOT_QUOTE_CREATOR_ERROR: 'COMMON_TYPES.GET_SPOT_QUOTE_CREATOR_ERROR',
  GET_SPOT_QUOTE_CREATOR_SUCCESS: 'COMMON_TYPES.GET_SPOT_QUOTE_CREATOR_SUCCESS',
  GET_SPOT_QUOTE_TRANSPORTATION_MODES_IN_ERROR: 'COMMON_TYPES.GET_SPOT_QUOTE_TRANSPORTATION_MODES_IN_ERROR',
  GET_SPOT_QUOTE_TRANSPORTATION_MODES_IN_PROGRESS: 'COMMON_TYPES.GET_SPOT_QUOTE_TRANSPORTATION_MODES_IN_PROGRESS',
  GET_SPOT_QUOTE_TRANSPORTATION_MODES_IN_SUCCESS: 'COMMON_TYPES.GET_SPOT_QUOTE_TRANSPORTATION_MODES_IN_SUCCESS',
  REMOVE_CURRENT_QUOTE_CARRIER: 'COMMON_TYPES.REMOVE_CURRENT_QUOTE_CARRIER',
  REMOVE_CURRENT_QUOTE_COLLABORATORS: 'COMMON_TYPES.REMOVE_CURRENT_QUOTE_COLLABORATORS',
  RESET_COPY_QUOTE_KEY: 'COMMON_TYPES.RESET_COPY_QUOTE_KEY',
  RESET_CURRENT_QUOTE_CARRIER: 'COMMON_TYPES.RESET_CURRENT_QUOTE_CARRIER',
  RESET_CURRENT_QUOTE_COLLABORATORS: 'COMMON_TYPES.RESET_CURRENT_QUOTE_COLLABORATORS',
  RESET_CURRENT_QUOTE_ROUTING_GUIDES_PARAMS: 'COMMON_TYPES.RESET_CURRENT_QUOTE_ROUTING_GUIDES_PARAMS',
  RESET_QUOTE_BID_EXPIRATION_DATE: 'COMMON_TYPES.RESET_QUOTE_BID_EXPIRATION_DATE',
  SET_APP_LOADER: 'COMMON_TYPES.SET_APP_LOADER',
  SET_COPY_QUOTE_KEY: 'COMMON_TYPES.SET_COPY_QUOTE_KEY',
  SET_CURRENT_QUOTE_CARRIERS: 'COMMON_TYPES.SET_CURRENT_QUOTE_CARRIERS',
  SET_CURRENT_QUOTE_COLLABORATORS: 'COMMON_TYPES.SET_CURRENT_QUOTE_COLLABORATORS',
  SET_CURRENT_QUOTE_ROUTING_GUIDES_PARAMS: 'COMMON_TYPES.SET_CURRENT_QUOTE_ROUTING_GUIDES_PARAMS',
  SET_DOCUMENT_TYPES_LIST: 'COMMON_TYPES.SET_DOCUMENT_TYPES_LIST',
  SET_FILTER_TOGGLE: 'COMMON_TYPES.SET_FILTER_TOGGLE',
  SET_FULL_SCREEN_INSTANCE: 'COMMON_TYPES.SET_FULL_SCREEN_INSTANCE',
  SET_LAD_CLAIM_PROCESSOR_LIST: 'COMMON_TYPES.SET_LAD_CLAIM_PROCESSOR_LIST',
  SET_LAD_CLAIMS_REGION_LIST: 'COMMON_TYPES.SET_LAD_CLAIMS_REGION_LIST',
  SET_LD_CLAIMS_COMMODITY_CODE_LIST: 'COMMON_TYPES.SET_LD_CLAIMS_COMMODITY_CODE_LIST',
  SET_LD_CLAIMS_LID_LABEL_LIST: 'COMMON_TYPES.SET_LD_CLAIMS_LID_LABEL_LIST',
  SET_LOSS_AND_DAMAGE_STATUS_LIST: 'COMMON_TYPES.SET_LOSS_AND_DAMAGE_STATUS_LIST',
  SET_PAGE_BLOCKER: 'COMMON_TYPES.SET_PAGE_BLOCKER',
  SET_PALLET_PACKAGE_TYPE_LIST: 'COMMON_TYPES.SET_PALLET_PACKAGE_TYPE_LIST',
  SET_QUOTE_ACTIVE_ACCORDIONS: 'COMMON_TYPES.SET_QUOTE_ACTIVE_ACCORDIONS',
  SET_QUOTE_BID_EXPIRATION_DATE: 'COMMON_TYPES.SET_QUOTE_BID_EXPIRATION_DATE',
  SET_QUOTE_MODAL_BLOCKER: 'COMMON_TYPES.SET_QUOTE_MODAL_BLOCKER',
  SET_QUOTE_SPOT_BID_SAVE_ERROR: 'COMMON_TYPES.SET_QUOTE_SPOT_BID_SAVE_ERROR',
  SET_SHIPMENT_APPOINTMENT_TYPES_LIST: 'COMMON_TYPES.SET_SHIPMENT_APPOINTMENT_TYPES_LIST',
  SET_SHIPMENT_PRODUCT_DIM_UOM_LIST: 'COMMON_TYPES.SET_SHIPMENT_PRODUCT_DIM_UOM_LIST',
  SET_SHIPMENT_PRODUCT_QTY_UOM_LIST: 'COMMON_TYPES.SET_SHIPMENT_PRODUCT_QTY_UOM_LIST',
  SET_SHIPMENT_SIDE_BAR_TOGGLE: 'COMMON_TYPES.SET_SHIPMENT_SIDE_BAR_TOGGLE',

  SET_SHIPMENT_STOP_TYPES_LIST: 'COMMON_TYPES.SET_SHIPMENT_STOP_TYPES_LIST',
  SET_WARNING_MODAL: 'COMMON_TYPES.SET_WARNING_MODAL',
};

// biome-ignore lint/style/noDefaultExport: TODO: fix
export default CommonTypes;
